import React, { useState } from 'react'
import { Form, Field } from 'redux-form'

import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import config from 'src/config'

import Button from 'components/Button'
import CheckboxRow from 'components/Input/CheckboxRow'
import InputMessage from 'components/Input/InputMessage'
import { vRequired } from 'components/Input/Input.validations'

import cn from 'classnames'
import s from '../BillingAddCreditCardForm/BillingAddCreditCardForm.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import sLay from 'styles/modules/layout.scss'

const stripe = loadStripe(config.other.stripePublicKey)

export default props => {
  const [status, setStatus] = useState({
    error: undefined,
    empty: true,
    complete: false,
  })

  const [submitting, setSubmitting] = useState(false)

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        fontSize: '20px',
      },
    },
    hidePostalCode: true,
  }

  const { handleSubmit, payBill, bill, afterPay, formData, modalConfirm, modalCancel } = props

  return (
    <Elements stripe={stripe}>
      <ElementsConsumer>
        {({ elements, stripe }) => {
          const onSubmit = async () => {
            setSubmitting(true)

            const result = await stripe
              .createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
              })
              .finally(() => setSubmitting(false))

            if (result.error || !result.paymentMethod) {
              const error = result.error || { message: 'Something goes wrong, please retry' }
              setStatus({ error, empty: true, complete: false })

              return
            }

            setSubmitting(true)

            await payBill({
              billId: bill.id,
              ban: bill.ban,
              useAsDefault: formData.useAsDefault,
              paymentMethodId: result.paymentMethod.id,
            })
              .then(() => {
                if (afterPay) {
                  afterPay()
                }
                modalConfirm()
              })
              .finally(() => setSubmitting(false))
          }

          return (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className={s.ccCountryNotice}>
                <b>Note:</b> We only accept Australian cards.
              </div>

              <CardElement options={CARD_ELEMENT_OPTIONS} onChange={event => setStatus(event)} />
              <InputMessage error={status.error?.message} touched />

              <div className={cn(sText.descrip4, sMarg.mv30)}>
                1.9% payment surcharge applies.{' '}
                <a
                  href="https://helpcentre.thinkpickle.com.au/account-management/avoiding-credit-card-surcharge"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more.
                </a>
              </div>

              <Field name="useAsDefault" component={CheckboxRow}>
                Use this card as default payment method for direct debit
              </Field>

              {formData.useAsDefault && (
                <Field
                  name="confirm"
                  component={CheckboxRow}
                  style={{ margin: '30px 0' }}
                  validate={[vRequired]}
                >
                  I understand and agree to the payment and direct debit{' '}
                  <a href="/payment-terms" target="_blank" rel="noopener noreferrer">
                    terms and conditions
                  </a>{' '}
                  and I acknowledge that these terms are binding on me or the company that I am to
                  represent.
                </Field>
              )}

              <div
                className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
                style={{ marginTop: '40px' }}
              >
                <Button
                  color="tertiary"
                  type="submit"
                  loading={submitting}
                  disabled={
                    !stripe ||
                    !elements ||
                    !status.complete ||
                    submitting ||
                    (formData.useAsDefault && !formData.confirm)
                  }
                >
                  Pay
                </Button>

                <br />
                <br />

                <Button plain onClick={modalCancel}>
                  Cancel
                </Button>
              </div>
            </Form>
          )
        }}
      </ElementsConsumer>
    </Elements>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/PayWithCreditCardForm/PayWithCreditCardForm.jsx